/* eslint-disable max-len */
import React, {useEffect} from 'react'
import { motion } from 'framer-motion'

export default function AddressSection({type,Details,addressList}) {

    const AddressComponent = ({ship,i}) => (
        <div className="border border-[#44445E] sm:pl-[26px] pl-4 sm:pb-[33px] pb-5 pt-3 rounded-lg">
            <div className={`flex justify-end`}>
                <p className={`text-xs2 font-normal text-[#FFFFFF] bg-[#44445E] rounded-lg rounded-tr-none rounded-br-none px-[9px] py-1 w-fit ${i===0 ? 'opacity-1':'opacity-0'}`}>
                    Default</p>
            </div>
            <p className="text-base font-normal text-[#090406]">{ship?.ADDRESS1},</p>
            {ship?.ADDRESS2 !== null && <p className="text-base font-normal text-[#090406]">{ship?.ADDRESS2},</p>}
            {ship?.ADDRESS3 !== null && <p className="text-base font-normal text-[#090406]">{ship?.ADDRESS3},</p>}
            {ship?.ADDRESS4 !== null && <p className="text-base font-normal text-[#090406]">{ship?.ADDRESS4},</p>}
            <p className="text-base font-normal text-[#090406]">{ship?.CITY} - {ship?.POSTAL_CODE}, </p>
            <p className="text-base font-normal text-[#090406]">{ship?.STATE}, {ship?.COUNTRY}, - {ship?.SITE_GSTIN || '-'}</p>
        </div>
    )
    return (
        <motion.div 
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.15 }}
            key={type}
            className={`tab-pane fade  pt-[18px] ${type==='Addresses' ? 'show active':''}`} id="pills-address" role="tabpanel" aria-labelledby="pills-address-tab">
            <h5 className="md:text-xs16 text-base font-bold text-[#555259]">Billings Address ({addressList.filter((val)=>val.SITE_USE_CODE==='BILL_TO').length})</h5>
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-7 md:gap-5 gap-4 mt-[18px]">
                {addressList.filter((val)=>val.SITE_USE_CODE==='BILL_TO').map((bill,i)=>(
                    <div key={bill.SITE_USE_CODE}>
                        <div key={bill.SITE_USE_CODE}>
                            <AddressComponent ship={bill} i={i} />
                        </div>
                    </div>
                ))}
            </div>
            <h5 className="md:text-xs16 text-base font-bold text-[#555259] pt-4">Shipping Address ({addressList.filter((val)=>val.SITE_USE_CODE==='SHIP_TO').length})</h5>
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-7 md:gap-5 gap-4 mt-[18px]">
                {addressList.filter((val)=>val.SITE_USE_CODE==='SHIP_TO').map((ship,i)=>(
                    <div key={ship.SITE_USE_CODE}>
                        <AddressComponent ship={ship} i={i} />
                    </div>
                    
                ))}
            </div>
        </motion.div>
    )
}